import { Skeleton } from '../../components/ui/skeleton';
import { TableCell, TableRow } from '../../components/ui/table';

interface TableSkeletonProps {
  /** Сколько колонок в таблице — каркас должен совпадать с будущей разметкой. */
  columns: number;
  rows?: number;
  /** Первая колонка обычно шире остальных (имя аккаунта, превью). */
  firstColumnWide?: boolean;
}

/**
 * Каркас строк таблицы вместо спиннера: высота строки та же, что у готовых
 * данных, поэтому при загрузке страница не прыгает.
 */
export function TableSkeleton({ columns, rows = 8, firstColumnWide = true }: TableSkeletonProps): JSX.Element {
  return (
    <>
      {Array.from({ length: rows }).map((_, rowIndex) => (
        <TableRow key={rowIndex}>
          {Array.from({ length: columns }).map((__, columnIndex) => (
            <TableCell key={columnIndex} className="h-14">
              <Skeleton
                className={
                  columnIndex === 0 && firstColumnWide ? 'h-4 w-40' : 'ml-auto h-4 w-16'
                }
              />
            </TableCell>
          ))}
        </TableRow>
      ))}
    </>
  );
}
